export enum MessageType {
    CLEARING_DASHBOARD = "CLEARING_DASHBOARD",
    TRADING_ALERT = "TRADING_ALERT",
    ORDER_FILLED = "ORDER_FILLED",
    POSITION_ALERT = "POSITION_ALERT",
    TRADE_IDEA = "TRADE_IDEA"
}
